import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { isEmpty } from 'Utilities/helpers';
import proPropTypes from 'Utilities/proPropTypes';

import styles from './Tag.module.scss';

const Tag = ({ children = '', className = '', element: Element = 'div', ...props }) => {
	if (isEmpty(children)) {
		return null;
	}

	return (
		<Element className={cx(styles.tag, className)} {...props}>
			{children}
		</Element>
	);
};

Tag.propTypes = {
	children: PropTypes.node,
	className: proPropTypes.className,
	element: PropTypes.oneOf(['div', 'li']),
};

export default Tag;
